export default "__VITE_ASSET__BW3daeDl__"